import { render, staticRenderFns } from "./StepResumo.vue?vue&type=template&id=6cc20f2d&scoped=true"
import script from "./StepResumo.vue?vue&type=script&lang=js"
export * from "./StepResumo.vue?vue&type=script&lang=js"
import style0 from "./StepResumo.vue?vue&type=style&index=0&id=6cc20f2d&prod&scoped=true&lang=css"
import style1 from "@/components/regras/regra-resumo.css?vue&type=style&index=1&id=6cc20f2d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc20f2d",
  null
  
)

export default component.exports